import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import FileField from "../../components/FileField";
import { actionChangeField } from "../../store/invoice/create/actions";
import { FieldFileFC } from "./types";

const FieldFile: FieldFileFC = ({saving}) => {
  const dispatch = useDispatch();
  const { value, error } = useSelector(
    ({
      invoice: {
        create: { invoice, errors },
      },
    }) => ({ value: invoice.file, error: errors?.file ?? false })
  );
  const [fileName, setFileName] = useState<{ name: string }>();


  const toBase64 = (file: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to read file as DataURL'));
      }
    };
    reader.onerror = reject;
  });


  const handlerChange = async (files: File[]) => {
    const base = await toBase64(files[0]);
    setFileName({name: files[0].name})
    dispatch(actionChangeField({ field: "file", value: base }));
  };

  return (
    <FileField
      disabled={saving}
      accept={"*/*"}
      onChange={handlerChange}
      error={error}
      value={fileName}
    />
  );
};

export default FieldFile;
